




















import {Component, Prop, Vue} from 'vue-property-decorator'
import axios from 'axios';

@Component
export default class SubscriptionForm extends Vue {

    @Prop()
    stripeClientSecret!: string;

    @Prop()
    stripeSecretKey!: string;

    @Prop()
    planId!: string;

    private error: string | null = null;
    private cardError: string | null = null;
    private errors: any = {};

    private loading: boolean = false;

    // @ts-ignore
    private stripe = Stripe(this.stripeSecretKey);

    private card!: any;


    private clear() {
        this.errors = {};
        this.loading = false;
    }

    private mounted() {
        // Create an instance of Elements.
        const elements = this.stripe.elements();

        // Create an instance of the card Element.
        this.card = elements.create('card', {
            style: {
                base: {
                    color: '#171616',
                    fontFamily: 'Rubik, Helvetica Neue, Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#a0aec0'
                    }
                },
                invalid: {
                    color: '#b14c56',
                    iconColor: '#b14c56'
                }
            },
            iconStyle: 'default',
            hidePostalCode: true
        });

        this.$nextTick(() => {
            // Add an instance of the card Element into the `card-element` <div>.
            this.card.mount('#card-input');

            // Handle real-time validation errors from the card Element.
            this.card.addEventListener('change', (data: any) => {
                this.cardError = data.error?.message || null;
            });
        });
    }

    private async submit() {
        if (this.loading) {
            return
        }

        this.clear();
        this.loading = true;

        // This call can trigger a 3D Secure dialog
        const {setupIntent, error} = await this.stripe.confirmCardSetup(
            this.stripeClientSecret,
            {
                payment_method: {
                    card: this.card
                }
            }
        );

        if (error) {
            this.loading = false;
            this.cardError = error.message;
            return;
        }

        // card has been verified successfully

        axios.post('/subscription', {
            'plan_id': this.planId,
            'payment_method': setupIntent.payment_method
        })
            .then(result => {
                const data = result.data;
                if (data.success || data.incomplete) {
                    window.location = data.redirect_url || "/";
                }
            })
            .catch(error => {
                this.loading = false;
                this.clear();
                this.error = error.response?.data.message || 'Something went wrong'
                this.errors = error.response?.data.errors || {}
            })
    }
}
